import { Injectable } from '@angular/core';
import {
  Action,
  AngularFirestore,
  AngularFirestoreCollection,
  DocumentChangeAction,
  DocumentReference,
  DocumentSnapshot,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Plantilla } from '../models/plantilla';

@Injectable({
  providedIn: 'root'
})
export class PlantillasService {

  private plantillaCollection: AngularFirestoreCollection<Plantilla>;

  constructor(private db: AngularFirestore) {
    this.plantillaCollection = this.db.collection<Plantilla>('plantillas');
  }

  /**
   * GET ALL TASKS
   */
  getAllPlantillas(): Observable<DocumentChangeAction<Plantilla>[]> {
    return this.plantillaCollection.snapshotChanges();
  }

  /**
   * GET TASK BY ID
   * @param plantillaId
   */
  getPlantilla(plantillaId: string): Observable<Action<DocumentSnapshot<Plantilla>>> {
    return this.plantillaCollection.doc<Plantilla>(plantillaId).snapshotChanges();
  }

  /**
   * CREATE NEW TASK
   * @param newPlantilla
   */
  createPlantilla(newPlantilla: Plantilla): Promise<DocumentReference> {
    return this.plantillaCollection.add(newPlantilla);
  }

  /**
   * UPDATE SELECTED TASK
   * @param data
   * @param docId
   */
  updatePlantilla(data: Plantilla, docId: string): Promise<void> {
    return this.plantillaCollection.doc<Plantilla>(docId).update(data);
  }

  /**
   * DELETE TASK
   * @param docId
   */
  deletePlantilla(docId: string): Promise<void> {
    return this.plantillaCollection.doc<Plantilla>(docId).delete();
  }
}

